module.exports = __webpack_public_path__ + "static/media/RRARAppleFeature.8c8f8dbe.JPG";